import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import { jsonToQueryString } from '@/utils'

import { ApplicationState } from '@/state/root.models'
import { RestApiService } from '@/services'
import { setLoadingFullAction } from '@/state/ui/global/slices/index.slices'

import { BONUS_PROGRAMS } from './api.routes'
import ActionTypes from '../constants'
import {
  GetOneBonusPayload,
  BonusResponseStatus,
  BonusEngineState,
} from '../models'

const restApiService: RestApiService = Container.get(RestApiService)

export const getOneBonusThunk = createAsyncThunk(
  ActionTypes.GET_ONE_BONUS_ENGINE,
  async (payload: GetOneBonusPayload, thunkAPI) => {
    try {
      restApiService.requestParams = {
        method: 'GET',
        endpoint: BONUS_PROGRAMS.FIND_ID,
        queries: jsonToQueryString(payload),
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: BonusResponseStatus = await restApiService.getData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      throw error
    }
  },
)

const getOneBonusExtraReducer = (
  builder: ActionReducerMapBuilder<BonusEngineState>,
) => {
  builder.addCase(getOneBonusThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(getOneBonusThunk.fulfilled, (state, { payload }) => {
    state.isLoading = false
    state.currentBonus = payload
  })
}

export default getOneBonusExtraReducer
